import Link from "next/link";

const ViewMore = ({
  link,
  linkText,
  className,
  height,
  width,
  spanClass,
  svgClass,
  arrow,
}) => (
  <Link passHref href={link}>
    <a className={`flex justify-center items-center ${className}`}>
      {linkText}
      {arrow && (
        <span className={spanClass}>
          <svg
            className={`bi bi-arrow-right ${svgClass}`}
            fill="currentColor"
            height={height}
            viewBox="0 0 16 16"
            width={width}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
              fillRule="evenodd"
            />
          </svg>
        </span>
      )}
    </a>
  </Link>
);

export default ViewMore;
